import { request } from "@src/utils/apiClient";
import { SignolUtils } from "@src/utils";

/** dynamic-content-api */
const BASE_DYNAMIC_CONTENT = "/dynamic_content";
/** spitfire-activity-service */
const BASE_ACTIVITY = "/activity";
/** spitfire-support-service */
const BASE_SUPPORT_ROUTE = "/support";
/** admin_service */
const BASE_ADMIN_SERVICE = "/adminDashboard";

export const getBehiveOutputs = (customer) => {
  return request({
    method: "GET",
    endpoint: BASE_ADMIN_SERVICE + "/behive-outputs",
    params: {
      prefix: `${SignolUtils.normalizeBehiveKey("prod/" + customer)}`,
    },
  });
};

export const getDynamicContent = (lang, industry) => {
  return request({
    method: "GET",
    endpoint: BASE_DYNAMIC_CONTENT + "/values",
    params: {
      industry,
      lang,
    },
  });
};

export const fetchBvrExclusions = async () => {
  return request({
    method: "GET",
    endpoint: BASE_DYNAMIC_CONTENT + "/behaviourExclusions",
  });
};

export const trackActivity = async (body) => {
  return request({
    method: "POST",
    endpoint: BASE_ACTIVITY + "/track",
    headers: {
      "Content-Type": "application/json",
    },
    body: body,
    isRetry: true, //don't retry if fail
  });
};

export const sendSupportRequest = async (body) => {
  return request({
    endpoint: BASE_SUPPORT_ROUTE + "/sendEmail",
    method: "POST",
    body: body,
  });
};
